export const VIN_FORM_FIELDS = ['vin', 'seller_id', 'auction_type'];
export const VEHICLE_FORM_FIELDS = [
  'year',
  'make',
  'model',
  'trim',
  'engine',
  'transmission',
  'drive_train',
  'ext_color',
  'mileage',
  'bluebook_auction_value_good',
  'bluebook_mileage',
  'bluebook_mileage_adjustment',
  'bluebook_value',
  'mileage',
  'options',
  'starting_bid',
  'reserve_price'
];
